import { shallowRef } from 'vue'

export const persistenceStatus = shallowRef<'idle' | 'opening' | 'ready' | 'unavailable'>('idle')

/** Performance entries contain stage names and durations only, never synced row contents. */
export function startStartupMeasure(stage: string): () => void {
  const start = performance.now()
  return () => {
    performance.measure(`meldeportal:${stage}`, { start, end: performance.now() })
  }
}
